import React from "react";

export const SvgGuestIcon = (props: any) => {
	return (
		<svg
			width="21"
			height="18"
			viewBox="0 0 21 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.8819 16.4943V14.8517C14.8819 13.9804 14.5371 13.1448 13.9234 12.5286C13.3096 11.9125 12.4772 11.5664 11.6092 11.5664H5.06374C4.19576 11.5664 3.36333 11.9125 2.74958 12.5286C2.13582 13.1448 1.79102 13.9804 1.79102 14.8517V16.4943"
				stroke="#666666"
				strokeWidth="1.85379"
				strokeLinecap="round"
				strokeLinejoin="round"
				{...props}
			/>
			<path
				d="M8.3362 8.28145C10.1437 8.28145 11.6089 6.81059 11.6089 4.99619C11.6089 3.1818 10.1437 1.71094 8.3362 1.71094C6.52873 1.71094 5.06348 3.1818 5.06348 4.99619C5.06348 6.81059 6.52873 8.28145 8.3362 8.28145Z"
				stroke="#666666"
				strokeWidth="1.85379"
				strokeLinecap="round"
				strokeLinejoin="round"
				{...props}
			/>
			<path
				d="M19.7905 16.4969V14.8543C19.7899 14.1264 19.5486 13.4193 19.1043 12.844C18.6601 12.2687 18.038 11.8578 17.3359 11.6758"
				stroke="#666666"
				strokeWidth="1.85379"
				strokeLinecap="round"
				strokeLinejoin="round"
				{...props}
			/>
			<path
				d="M14.0635 1.81641C14.7674 1.99734 15.3914 2.40833 15.837 2.98458C16.2826 3.56082 16.5244 4.26955 16.5244 4.99902C16.5244 5.72849 16.2826 6.43721 15.837 7.01346C15.3914 7.5897 14.7674 8.00069 14.0635 8.18163"
				stroke="#666666"
				strokeWidth="1.85379"
				strokeLinecap="round"
				strokeLinejoin="round"
				{...props}
			/>
		</svg>
	);
};
